import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service'
import { provideAnimations } from '@angular/platform-browser/animations';
import { bearerInterceptor } from './interceptors/bearer.interceptor';
import { cookieInterceptor } from './interceptors/cookie.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { casiXsrfInterceptor } from './interceptors/casi-xsrf.interceptor';
//import { HttpRequestInterceptor } from './interceptors/request.intercetor';
import { spinnerInterceptor } from './interceptors/spinner.interceptor';
import { provideToastr } from 'ngx-toastr';
import { cookieHeaderName, csrfTokenName } from './common/constants.lib';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })),
    provideHttpClient(
      withXsrfConfiguration({
        cookieName: cookieHeaderName, // 'X-CSRF-TOKEN',
        headerName: csrfTokenName //'X-CSRF-TOKEN'
      }),
      // { provide: HTTP_INTERCEPTORS, useClass: casiXsrfInterceptor, multi: true },
      // { provide: HttpXsrfTokenExtractor, useClass: HttpXsrfTokenExtractor },
      withInterceptors([casiXsrfInterceptor, bearerInterceptor,
        cookieInterceptor, spinnerInterceptor])
    ),
    provideAnimations(),
    provideToastr({
      timeOut: 2000,
      positionClass: 'toast-bottom-center',
      preventDuplicates: true
    }),
    CookieService,
    provideAnimationsAsync()
    // {
    //   provide: EVENT_MANAGER_PLUGINS,
    //   useClass: ZonelessEventPluginService,
    //   multi: true
    // }
  ],

};
